<template>
    
    <argon-modal :show="modal.show"
    body-classes="p-0"
    modal-classes="modal-dialog-centered"
    headerClasses="modal-header"
    >
    
    <template v-slot:header v-if="false">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
    </template>
    <template v-slot:body>
        
        <div class="py-4 container-fluid">
            <div class="row">
                <Form     
                :titlePage="modal.titlePage"
                :subtitlePage="modal.subtitlePage"
                :submitButtonName="modal.submitButtonName"
                :onSubmit="onSubmit"
                :onCancel="onCancel"
                :recordProps="record" />
                
            </div>
        </div>
    </template>
    
</argon-modal>
</template>

<script>
import ArgonModal from "@/components/ArgonModal.vue";
import Form from "./Form.vue";


export default {
    data() {
        return {
            record: {},
            modal: {}
        };
    },
    props: {
        show: { type: Boolean, default: false},
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        onCancel: { type: Function },
        recordProps: { type: Object },
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.record = newVal
        },
        show: function (newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.modal['show'] = newVal
        },
        titlePage: function (newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.modal['titlePage'] = newVal
        },
        subtitlePage: function (newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.modal['subtitlePage'] = newVal
        },
        submitButtonName: function (newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.modal['submitButtonName'] = newVal
        },
        onSubmit: function (newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.modal['onSubmit'] = newVal
        },
    },
    components: {
        ArgonModal,
        Form
    },
    mounted() {
        
    },
}
</script>
